import script from "./base-list.vue?vue&type=script&lang=js"
export * from "./base-list.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__